"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _reactI18next = require("react-i18next");
var _hacks = require("../helpers/hacks");
var _misc = require("../helpers/misc");
exports.default = {
  eventtiaBase: 'https://connect.eventtia.com',
  setEventtiaBase: function setEventtiaBase(eventtiaBase) {
    this.eventtiaBase = eventtiaBase || this.eventtiaBase;
  },
  getApiRoot: function getApiRoot() {
    var locale = window.location.pathname.split('/')[1];
    if (!['en', 'es', 'fr'].includes(locale)) {
      locale = 'en';
    }
    return this.eventtiaBase + "/" + locale + "/api/v3/";
  },
  buildQuery: function buildQuery(params) {
    var keys = Object.keys(params);
    var params_string = '';
    if (keys.length) {
      params_string = "?" + keys.map(function (key) {
        return key + "=" + params[key];
      }).filter(function (k) {
        return k.split('=')[1].trim() !== 'undefined';
      }).join('&');
    }
    return params_string.length > 1 ? params_string : '';
  },
  getPublicRegisterUrl: function getPublicRegisterUrl(eventUri, attendee_type, event_id) {
    var query = this.buildQuery({
      attendee_type: attendee_type
    });
    var formLanguage = (0, _misc.getQueryParam)("form-language");
    if (['virtualityparis', 'verizon2019', 'fbf2020', '7934', 'franceattractive', '4th-international-workshops-of-eczema-foundation', '6emejourneeshospitalieres', 'pure2020', '2019'].includes(eventUri)) return this.eventtiaBase + "/" + (sessionStorage.getItem('website_lang') || window.location.pathname.split('/')[1]) + "/public/events/" + eventUri + "/registration/attendees" + query;
    if (['perrier-jouet-popup-event-h1', 'wine-seminar-fy24h1'].includes(eventUri)) return this.eventtiaBase + "/ja/public/events/" + eventUri + "/registration/attendees" + (query || window.location.search);
    if (eventUri === 'europeanbuyersforum26novembre2019') return this.eventtiaBase + "/" + window.location.pathname.split('/')[1] + "/dmz/" + eventUri + "/website/register" + query;
    if (eventUri === 'soirees-formation-a-derma') return this.eventtiaBase + "/" + window.location.pathname.split('/')[1] + "/dmz/" + eventUri + "/website/register" + this.buildQuery((0, _hacks.buildAdermaHackObject)(attendee_type));

    // New eventtia registration form
    if (event_id > 14455) return this.eventtiaBase + "/" + (formLanguage || sessionStorage.getItem('website_lang') || window.location.pathname.split('/')[1]) + "/public/events/" + eventUri + "/registration/attendees" + (query || window.location.search);
    return this.eventtiaBase + "/" + (formLanguage || sessionStorage.getItem('website_lang') || window.location.pathname.split('/')[1]) + "/dmz/" + eventUri + "/website/register" + query;
  },
  getPublicLoginUrl: function getPublicLoginUrl(eventUri, event_language) {
    return this.eventtiaBase + "/" + event_language + "/dmz/" + eventUri + "/website/login";
  },
  getSubmitContactFormUrl: function getSubmitContactFormUrl(eventUri) {
    return this.getApiRoot() + "events/" + eventUri + "/contact_message";
  },
  getSendEditRegistrationMagicTokenUrl: function getSendEditRegistrationMagicTokenUrl(eventUri) {
    return this.getApiRoot() + "events/" + eventUri + "/attendees/registration_magic_link_email";
  }
};